import React from 'react';
import { _defineHelpUrlandToolTip } from '../helpers/index.js'

const LogicNull = function () {
    const name = "logic_null";
    LogicNull.blockName = name;

    _defineHelpUrlandToolTip(name, Blockly.BASE_HELP_URL + "#logic");

    return (
        <block type={name}></block>
    );
};

export default LogicNull;
